import {
  DropdownDetails,
  opportunityErrorDetailsInterface,
  updateOpportunity,
} from 'Interfaces/BDPortalInterfaces';

export const createEmptyErrorDetailsObject = () => {
  return {
    concepts: {
      isError: false,
      accordionIndex: 0,
    },
    basicDetails: {
      isError: false,
      errorDetails: {
        source: false,
        strategy: false,
        agency: false,
        nadWaiver: false,
        siteTransfer: false,
      },
      accordionIndex: 1,
    },
    partners: {
      isError: false,
      errorDetails: {
        primaryPartner: false,
        backupPartner1: false,
        backupPartner2: false,
      },
      accordionIndex: 2,
    },
    financials: {
      isError: false,
      errorDetails: {
        estimateAnnRevenue: false,
        estimateAnnGP: false,
        expLaunchDate: false,
      },
      accordionIndex: 3,
    },
    ncDetails: {
      isError: false,
      errorDetails: {
        ncBidStatus: false,
        solicitationNumber: false,
        submissionDueDate: false,
        awardingAgency: false,
        reversionAction: false,
        negotiation: false,
        negotiationDate: false,
        fprDate: false,
        awardDate: false,
        awardee: false,
        awardedValue: false,
        gsmsBidValue: false,
      },
      accordionIndex: 4,
    },
  };
};

export const checkErrorForEditingOpportunitySave = (
  editingOpportunity: updateOpportunity,
  isOpportunityTypeNC: boolean,
  dropdownDetails: DropdownDetails
): opportunityErrorDetailsInterface => {
  // create empty error details
  const tempErrorDetails: opportunityErrorDetailsInterface = createEmptyErrorDetailsObject();

  // concepts

  // basic Details

  // partners
  // backyup partner1 can only be there if primary partners is ther
  if (editingOpportunity.BackupSupplierID1 && !editingOpportunity.PrimarySupplierID) {
    tempErrorDetails.partners.isError = true;
    tempErrorDetails.partners.errorDetails.primaryPartner = true;
  }

  // backyup partner2 can only be there if primary partners and backup partner1 are ther
  if (editingOpportunity.BackupSupplierID2) {
    if (!editingOpportunity.PrimarySupplierID) {
      tempErrorDetails.partners.isError = true;
      tempErrorDetails.partners.errorDetails.primaryPartner = true;
    }
    if (!editingOpportunity.BackupSupplierID1) {
      tempErrorDetails.partners.isError = true;
      tempErrorDetails.partners.errorDetails.backupPartner1 = true;
    }
  }

  // financials
  // no check for now

  // nc details if
  if (isOpportunityTypeNC) {
    // nc bid status validation
    if (editingOpportunity.NCBidStatusID) {
      if (
        dropdownDetails.NC.NCBidStatus?.filter(
          item => item.ID === editingOpportunity.NCBidStatusID
        )[0].NCBidStatus === 'Solicitation'
      ) {
        // solitication number and submission due date are both compulsory

        if (!editingOpportunity.SolicitationNumber) {
          tempErrorDetails.ncDetails.isError = true;
          tempErrorDetails.ncDetails.errorDetails.solicitationNumber = true;
        }

        if (!editingOpportunity.SubmissionDueDate) {
          tempErrorDetails.ncDetails.isError = true;
          tempErrorDetails.ncDetails.errorDetails.submissionDueDate = true;
        }
      }
    }

    // negotiation validation
    if (editingOpportunity.Negotiation && !editingOpportunity.NegotiationDate) {
      tempErrorDetails.ncDetails.isError = true;
      tempErrorDetails.ncDetails.errorDetails.negotiationDate = true;
    }

    // awarding agency
    if (editingOpportunity.AwardeeID) {
      // negotitation date is compulsory
      if (!editingOpportunity.AwardDate) {
        tempErrorDetails.ncDetails.isError = true;
        tempErrorDetails.ncDetails.errorDetails.awardDate = true;
      }
      if (!editingOpportunity.AwardedValue) {
        tempErrorDetails.ncDetails.isError = true;
        tempErrorDetails.ncDetails.errorDetails.awardedValue = true;
      }
      if (!editingOpportunity.GSMSBidValue) {
        tempErrorDetails.ncDetails.isError = true;
        tempErrorDetails.ncDetails.errorDetails.gsmsBidValue = true;
      }
    }
  }
  return tempErrorDetails;
};

export const getErrorAccordionIndexesFromErrorDetails = (
  errorDetails: opportunityErrorDetailsInterface
) => {
  const errorIndexes: number[] = [];
  if (errorDetails.concepts.isError) {
    errorIndexes.push(errorDetails.concepts.accordionIndex);
  }
  if (errorDetails.basicDetails.isError) {
    errorIndexes.push(errorDetails.basicDetails.accordionIndex);
  }
  if (errorDetails.partners.isError) {
    errorIndexes.push(errorDetails.partners.accordionIndex);
  }
  if (errorDetails.financials.isError) {
    errorIndexes.push(errorDetails.financials.accordionIndex);
  }
  if (errorDetails.ncDetails.isError) {
    errorIndexes.push(errorDetails.ncDetails.accordionIndex);
  }
  return errorIndexes;
};
